import {CallCenterAgentStatus} from '@/classes/dto/api-handler/response/placetel/api/CallCenterAgent.placetel.response.dto';

export type CallCenterAgentStatusInfo = { text: string; color: string; icon: string };

export const CALL_CENTER_AGENT_STATUS_META: Record<CallCenterAgentStatus, CallCenterAgentStatusInfo> = {
    online: {text: 'Online', color: 'success', icon: 'mdi-headset'},
    // warning (#FFC107) ist auf der gelben AppBar kaum sichtbar
    pause: {text: 'Pause', color: 'orange darken-2', icon: 'mdi-coffee'},
    offline: {text: 'Offline', color: 'grey', icon: 'mdi-headset-off'},
    working: {text: 'Nachbearbeitung', color: 'info', icon: 'mdi-clipboard-edit-outline'},
    dail_out: {text: 'Ausgehender Anruf', color: 'info', icon: 'mdi-phone-outgoing'},
};

/** Unbekannte Status (falls Placetel neue einführt) werden als Rohwert angezeigt */
export const getCallCenterAgentStatusInfo = (status: string | null | undefined): CallCenterAgentStatusInfo => {
    return (status && CALL_CENTER_AGENT_STATUS_META[status as CallCenterAgentStatus])
        || {text: status || 'Unbekannt', color: 'grey', icon: 'mdi-headset'};
};

/** Tone class (modern.css) of the status pill in the app bar */
export const getCallCenterAgentStatusTone = (status: string | null | undefined): string => {
    switch (status) {
        case 'online':
            return 'tone-good';
        case 'pause':
            return 'tone-warn';
        case 'working':
        case 'dail_out':
            return 'tone-info';
        default:
            return 'tone-muted';
    }
};
